module.exports = {
  hero: {
    title: "Brainstorming for desired perfect Usability",
    description:
      "Our design projects are fresh and simple and will benefit your business greatly. Learn more about our work!",
    bgImage: "img/app-hero-bg.jpg"
  },
  promo: {
    title: "Why small business owners love AppCo?",
    description:
      "Following reasons show advantages of adding AgencyCo to your lead pages, demos and checkouts",
    items: [
      {
        title: "Clean Design",
        description:
          "Increase sales by showing true dynamics of your website",
        icon: "ti-vector text-white"
      },
      {
        title: "Secure Data",
        description:
          "Build your online store’s trust using Social Proof & Urgency",
        icon: "ti-lock text-white"
      },
      {
        title: "Retina Ready",
        description:
          "Realize importance of social proof in customer’s purchase decision",
        icon: "ti-eye text-white"
      }
    ]
  },
  aboutUs: {
    title: {
      bold: "Use your android or ios device",
      normal: ""
    },
    description:
      "Following reasons show advantages of adding AgencyCo to your lead pages, demos and checkouts",
    items: [
      {
        title: "Clean Design",
        description:
          "Increase sales by showing true dynamics of your website",
        icon: "ti-vector text-white"
      },
      {
        title: "Secure Data",
        description:
          "Build your online store’s trust using Social Proof & Urgency",
        icon: "ti-lock text-white"
      },
      {
        title: "Retina Ready",
        description:
          "Realize importance of social proof in customer’s purchase decision",
        icon: "ti-eye text-white"
      }
    ]
  },
  price: {
    title: "Pricing Packages",
    description:
      "Uniquely maintain efficient expertise whereas cross functional deliverables. Continually leverage other's competitive mind share whereas enabled channels. ",
    packages: [
      {
        price: "$29",
        license: "Basic",
        isFeatured: false,
        features: [
          "Push Notifications",
          "Data Transfer",
          "SQL Database",
          "Search & SEO Analytics",
          "24/7 Phone Support",
          "2 months technical support",
          "2+ profitable keyword"
        ]
      },
      {
        price: "$50",
        license: "Popular",
        isFeatured: true,
        features: [
          "Push Notifications",
          "Data Transfer",
          "SQL Database",
          "Search & SEO Analytics",
          "24/7 Phone Support",
          "6 months technical support",
          "30+ profitable keyword"
        ]
      },
      {
        price: "$120",
        license: "Extended",
        isFeatured: false,
        features: [
          "Push Notifications",
          "Data Transfer",
          "SQL Database",
          "Search & SEO Analytics",
          "24/7 Phone Support",
          "1 year technical support",
          "70+ profitable keyword"
        ]
      }
    ]
  },
  testimonial: {
    title: "What customer say about us",
    description:
      'Rapidiously morph transparent internal or "organic" sources whereas resource sucking e-business. Conveniently innovate compelling internal.',
    comments: [
      {
        name: "Arabella Ora",
        company: "AgencyCo",
        image: "img/client-2.jpg",
        comment:
          "Completely build backend ROI whereas cross-media metrics. Collaboratively deploy customer directed web-readiness via global testing procedures. Appropriately reinvent distributed innovation without proactive catalysts for change. Distinctively."
      },
      {
        name: "John Charles",
        company: "ThemeTags",
        image: "img/client-1.jpg",
        comment:
          "If you can design one thing you can design everything with Front. Just believe it. Collaboratively repurpose performance based e-commerce without cost. It's beautiful and the coding is done quickly and seamlessly."
      },
      {
        name: "Jeremy Jere",
        company: "WorldCheck",
        image: "img/client-3.jpg",
        comment:
          "The template is really nice and offers quite a large set of options. It's beautiful and the coding is done. If you can design one thing you can design everything with Front. Just believe it."
      },
      {
        name: "Ciaran Kierce",
        company: "AppCo",
        image: "img/client-4.jpg",
        comment:
          "I just wanted to share a quick note and let you know that you guys do a really good job. I’m glad I decided to work with you. It’s really great how easy your websites are to update and manage. I never have any problem at all."
      }
    ]
  },
  contact: {
    title: "Contact with us",
    description:
      "It's very easy to get in touch with us. Just use the contact form or pay us a visit for a coffee at the office. Dynamically innovate competitive technology after an expanded array of leadership.",

    office: "Head Office",
    address: "121 King St, Melbourne VIC 3000, Australia",
    phone: "+61 2 8376 6284",
    email: "hello@yourdomain.com"
  },
  trustedCompany: [
    "img/client-1-color.png",
    "img/client-6-color.png",
    "img/client-3-color.png",
    "img/client-4-color.png",
    "img/client-5-color.png"
  ],
  trustedCompanyGray: [
    "img/client-1-gray.png",
    "img/client-2-gray.png",
    "img/client-3-gray.png",
    "img/client-4-gray.png",
    "img/client-5-gray.png"
  ],
  trustedCompanyAboutUs: {
    title: "Trusted by companies",
    description: "Rapidiously morph transparent internal or \"organic\" sources whereas resource sucking e-business. Conveniently innovate compelling internal.",
    companies: [
      "img/client-5-color.png",
      "img/client-1-color.png",
      "img/client-6-color.png",
      "img/client-3-color.png",
      "img/client-4-color.png",
      "img/client-5-color.png",
      "img/client-7-color.png",
      "img/client-2-color.png",
      "img/client-1-color.png",
      "img/client-3-color.png"
    ]
  },
  teamMember: {
    members: [
      {
        name: "Edna Mason",
        designation: "Senior Designer",
        image: "img/team-4.jpg"
      },
      {
        name: "Arabella Ora",
        designation: "Senior Designer",
        image: "img/team-1.jpg"
      },
      {
        name: "John Charles",
        designation: "Senior Designer",
        image: "img/team-2.jpg"
      },
      {
        name: "Jeremy Jere",
        designation: "Senior Designer",
        image: "img/team-3.jpg"
      },
    ]
  },
  video: {
    link: "https://www.youtube.com/watch?v=9No-FiEInLA"
  },
  kussens: {
    zacht: {
      smal: {
        rug: [
          {
            naam: "Nobile 450 gram",
            image: "https://www.am-products.nl/wp-content/uploads/2016/11/nobile-1.jpg",
            link: "https://www.am-products.nl/kussen/dons-hoofdkussen-nobile/",
            materiaal: "dons"
          },
          {
            naam: "Eminent 12cm",
            image: "https://www.am-products.nl/wp-content/uploads/2016/02/eminent-1.jpg",
            link: "https://www.am-products.nl/kussen/dons-natuurlatex-hoofdkussen-eminent/",
            materiaal: "dons"
          },
          {
            naam: "Rondo 12cm",
            image: "https://www.am-products.nl/wp-content/uploads/2017/06/rondo.jpg",
            link: "https://www.am-products.nl/kussen/traagschuim-kussen-rondo/",
            materiaal: "mindfoam"
          },
          {
            naam: "Coda 11cm",
            image: "https://www.am-products.nl/wp-content/uploads/2016/02/coda.jpg",
            link: "https://www.am-products.nl/kussen/traagschuim-hoofdkussen-coda/",
            materiaal: "mindfoam"
          },
          {
            naam: "Fresco 9cm",
            image: "https://www.am-products.nl/wp-content/uploads/2018/12/fresco-1.jpg",
            link: "https://www.am-products.nl/kussen/ventilerend-traagschuim-hoofdkussen-fresco/",
            materiaal: "mindfoam"
          },
          {
            naam: "Sonate 12cm soft",
            image: "https://www.am-products.nl/wp-content/uploads/2016/02/sonate-1.jpg",
            link: "https://www.am-products.nl/kussen/latex-kussen-sonate/",
            materiaal: "natuurlatex"
          },
          {
            naam: "Inventio 9cm soft",
            image: "https://www.am-products.nl/wp-content/uploads/2020/02/inventio.jpg",
            link: "https://www.am-products.nl/kussen/ergonomisch-natuurlatex-hoofdkussen-inventio/",
            materiaal: "natuurlatex"
          },
          {
            naam: "Allegro 11cm soft",
            image: "https://www.am-products.nl/wp-content/uploads/2016/02/allegro-1.jpg",
            link: "https://www.am-products.nl/kussen/talalay-latex-hoofdkussen-allegro/",
            materiaal: "talalay"
          },
          {
            naam: "Marcato 11cm soft",
            image: "https://www.am-products.nl/wp-content/uploads/2016/02/marcato-1.jpg",
            link: "https://www.am-products.nl/kussen/talalay-natuurlatex-hoofdkussen-marcato/",
            materiaal: "talalay"
          }
        ],
        zij: [
          {
            naam: "Eminent 12cm",
            image: "https://www.am-products.nl/wp-content/uploads/2016/02/eminent-1.jpg",
            link: "https://www.am-products.nl/kussen/dons-natuurlatex-hoofdkussen-eminent/",
            materiaal: "dons"
          },
          {
            naam: "Rondo 12cm",
            image: "https://www.am-products.nl/wp-content/uploads/2017/06/rondo.jpg",
            link: "https://www.am-products.nl/kussen/traagschuim-kussen-rondo/",
            materiaal: "mindfoam"
          },
          {
            naam: "Fresco 9cm",
            image: "https://www.am-products.nl/wp-content/uploads/2018/12/fresco-1.jpg",
            link: "https://www.am-products.nl/kussen/ventilerend-traagschuim-hoofdkussen-fresco/",
            materiaal: "mindfoam"
          },
          {
            naam: "Sonate 12cm soft",
            image: "https://www.am-products.nl/wp-content/uploads/2016/02/sonate-1.jpg",
            link: "https://www.am-products.nl/kussen/latex-kussen-sonate/",
            materiaal: "natuurlatex"
          },
          {
            naam: "Inventio 9cm soft",
            image: "https://www.am-products.nl/wp-content/uploads/2020/02/inventio.jpg",
            link: "https://www.am-products.nl/kussen/ergonomisch-natuurlatex-hoofdkussen-inventio/",
            materiaal: "natuurlatex"
          },
          {
            naam: "Vivente 12cm soft",
            image: "https://www.am-products.nl/wp-content/uploads/2016/11/vivente-1.jpg",
            link: "https://www.am-products.nl/kussen/natuurlatex-gezondheidskussen-vivente/",
            materiaal: "natuurlatex"
          },
          {
            naam: "Presto 10cm soft",
            image: "https://www.am-products.nl/wp-content/uploads/2016/02/presto-1.jpg",
            link: "https://www.am-products.nl/kussen/talalay-natuurlatex-kussen/",
            materiaal: "talalay"
          },
          {
            naam: "Marcato 11cm soft",
            image: "https://www.am-products.nl/wp-content/uploads/2016/02/marcato-1.jpg",
            link: "https://www.am-products.nl/kussen/talalay-natuurlatex-hoofdkussen-marcato/",
            materiaal: "talalay"
          }
        ],
        buik: [

        ]
      },
      normaal: {
        rug: [
          {
            naam: "Nobile 450 gram",
            image: "https://www.am-products.nl/wp-content/uploads/2016/11/nobile-1.jpg",
            link: "https://www.am-products.nl/kussen/dons-hoofdkussen-nobile/",
            materiaal: "dons"
          },
          {
            naam: "Eminent 12cm",
            image: "https://www.am-products.nl/wp-content/uploads/2016/02/eminent-1.jpg",
            link: "https://www.am-products.nl/kussen/dons-natuurlatex-hoofdkussen-eminent/",
            materiaal: "dons"
          },
          {
            naam: "Rondo 12cm",
            image: "https://www.am-products.nl/wp-content/uploads/2017/06/rondo.jpg",
            link: "https://www.am-products.nl/kussen/traagschuim-kussen-rondo/",
            materiaal: "mindfoam"
          },
          {
            naam: "Coda 11cm",
            image: "https://www.am-products.nl/wp-content/uploads/2016/02/coda.jpg",
            link: "https://www.am-products.nl/kussen/traagschuim-hoofdkussen-coda/",
            materiaal: "mindfoam"
          },
          {
            naam: "Fresco 9cm",
            image: "https://www.am-products.nl/wp-content/uploads/2018/12/fresco-1.jpg",
            link: "https://www.am-products.nl/kussen/ventilerend-traagschuim-hoofdkussen-fresco/",
            materiaal: "mindfoam"
          },
          {
            naam: "Sonate 12cm soft",
            image: "https://www.am-products.nl/wp-content/uploads/2016/02/sonate-1.jpg",
            link: "https://www.am-products.nl/kussen/latex-kussen-sonate/",
            materiaal: "natuurlatex"
          },
          {
            naam: "Inventio 9cm soft",
            image: "https://www.am-products.nl/wp-content/uploads/2020/02/inventio.jpg",
            link: "https://www.am-products.nl/kussen/ergonomisch-natuurlatex-hoofdkussen-inventio/",
            materiaal: "natuurlatex"
          },
          {
            naam: "Allegro 11cm soft",
            image: "https://www.am-products.nl/wp-content/uploads/2016/02/allegro-1.jpg",
            link: "https://www.am-products.nl/kussen/talalay-latex-hoofdkussen-allegro/",
            materiaal: "talalay"
          },
          {
            naam: "Marcato 11cm soft",
            image: "https://www.am-products.nl/wp-content/uploads/2016/02/marcato-1.jpg",
            link: "https://www.am-products.nl/kussen/talalay-natuurlatex-hoofdkussen-marcato/",
            materiaal: "talalay"
          }
        ],
        zij: [
          {
            naam: "Eminent 12cm",
            image: "https://www.am-products.nl/wp-content/uploads/2016/02/eminent-1.jpg",
            link: "https://www.am-products.nl/kussen/dons-natuurlatex-hoofdkussen-eminent/",
            materiaal: "dons"
          },
          {
            naam: "Rondo 12cm",
            image: "https://www.am-products.nl/wp-content/uploads/2017/06/rondo.jpg",
            link: "https://www.am-products.nl/kussen/traagschuim-kussen-rondo/",
            materiaal: "mindfoam"
          },
          {
            naam: "Fresco 9cm",
            image: "https://www.am-products.nl/wp-content/uploads/2018/12/fresco-1.jpg",
            link: "https://www.am-products.nl/kussen/ventilerend-traagschuim-hoofdkussen-fresco/",
            materiaal: "mindfoam"
          },
          {
            naam: "Sonate 14cm soft",
            image: "https://www.am-products.nl/wp-content/uploads/2016/02/sonate-1.jpg",
            link: "https://www.am-products.nl/kussen/latex-kussen-sonate/",
            materiaal: "natuurlatex"
          },
          {
            naam: "Inventio 12cm soft",
            image: "https://www.am-products.nl/wp-content/uploads/2020/02/inventio.jpg",
            link: "https://www.am-products.nl/kussen/ergonomisch-natuurlatex-hoofdkussen-inventio/",
            materiaal: "natuurlatex"
          },
          {
            naam: "Vivente 12cm soft",
            image: "https://www.am-products.nl/wp-content/uploads/2016/11/vivente-1.jpg",
            link: "https://www.am-products.nl/kussen/natuurlatex-gezondheidskussen-vivente/",
            materiaal: "natuurlatex"
          },
          {
            naam: "Presto 10cm soft",
            image: "https://www.am-products.nl/wp-content/uploads/2016/02/presto-1.jpg",
            link: "https://www.am-products.nl/kussen/talalay-natuurlatex-kussen/",
            materiaal: "talalay"
          },
          {
            naam: "Marcato 11cm soft",
            image: "https://www.am-products.nl/wp-content/uploads/2016/02/marcato-1.jpg",
            link: "https://www.am-products.nl/kussen/talalay-natuurlatex-hoofdkussen-marcato/",
            materiaal: "talalay"
          }
        ],
        buik: [

        ]
      },
      breed: {
        rug: [
          {
            naam: "Nobile 600 gram",
            image: "https://www.am-products.nl/wp-content/uploads/2016/11/nobile-1.jpg",
            link: "https://www.am-products.nl/kussen/dons-hoofdkussen-nobile/",
            materiaal: "dons"
          },
          {
            naam: "Eminent 12cm",
            image: "https://www.am-products.nl/wp-content/uploads/2016/02/eminent-1.jpg",
            link: "https://www.am-products.nl/kussen/dons-natuurlatex-hoofdkussen-eminent/",
            materiaal: "dons"
          },
          {
            naam: "Rondo 12cm",
            image: "https://www.am-products.nl/wp-content/uploads/2017/06/rondo.jpg",
            link: "https://www.am-products.nl/kussen/traagschuim-kussen-rondo/",
            materiaal: "mindfoam"
          },
          {
            naam: "Coda 13cm",
            image: "https://www.am-products.nl/wp-content/uploads/2016/02/coda.jpg",
            link: "https://www.am-products.nl/kussen/traagschuim-hoofdkussen-coda/",
            materiaal: "mindfoam"
          },
          {
            naam: "Fresco 11cm",
            image: "https://www.am-products.nl/wp-content/uploads/2018/12/fresco-1.jpg",
            link: "https://www.am-products.nl/kussen/ventilerend-traagschuim-hoofdkussen-fresco/",
            materiaal: "mindfoam"
          },
          {
            naam: "Sonate 14cm soft",
            image: "https://www.am-products.nl/wp-content/uploads/2016/02/sonate-1.jpg",
            link: "https://www.am-products.nl/kussen/latex-kussen-sonate/",
            materiaal: "natuurlatex"
          },
          {
            naam: "Inventio 12cm soft",
            image: "https://www.am-products.nl/wp-content/uploads/2020/02/inventio.jpg",
            link: "https://www.am-products.nl/kussen/ergonomisch-natuurlatex-hoofdkussen-inventio/",
            materiaal: "natuurlatex"
          },
          {
            naam: "Allegro 13cm soft",
            image: "https://www.am-products.nl/wp-content/uploads/2016/02/allegro-1.jpg",
            link: "https://www.am-products.nl/kussen/talalay-latex-hoofdkussen-allegro/",
            materiaal: "talalay"
          },
          {
            naam: "Marcato 11cm soft",
            image: "https://www.am-products.nl/wp-content/uploads/2016/02/marcato-1.jpg",
            link: "https://www.am-products.nl/kussen/talalay-natuurlatex-hoofdkussen-marcato/",
            materiaal: "talalay"
          }
        ],
        zij: [
          {
            naam: "Eminent 12cm",
            image: "https://www.am-products.nl/wp-content/uploads/2016/02/eminent-1.jpg",
            link: "https://www.am-products.nl/kussen/dons-natuurlatex-hoofdkussen-eminent/",
            materiaal: "dons"
          },
          {
            naam: "Rondo 14cm",
            image: "https://www.am-products.nl/wp-content/uploads/2017/06/rondo.jpg",
            link: "https://www.am-products.nl/kussen/traagschuim-kussen-rondo/",
            materiaal: "mindfoam"
          },
          {
            naam: "Fresco 11cm",
            image: "https://www.am-products.nl/wp-content/uploads/2018/12/fresco-1.jpg",
            link: "https://www.am-products.nl/kussen/ventilerend-traagschuim-hoofdkussen-fresco/",
            materiaal: "mindfoam"
          },
          {
            naam: "Sonate 14cm soft",
            image: "https://www.am-products.nl/wp-content/uploads/2016/02/sonate-1.jpg",
            link: "https://www.am-products.nl/kussen/latex-kussen-sonate/",
            materiaal: "natuurlatex"
          },
          {
            naam: "Inventio 14cm soft",
            image: "https://www.am-products.nl/wp-content/uploads/2020/02/inventio.jpg",
            link: "https://www.am-products.nl/kussen/ergonomisch-natuurlatex-hoofdkussen-inventio/",
            materiaal: "natuurlatex"
          },
          {
            naam: "Vivente 14cm soft",
            image: "https://www.am-products.nl/wp-content/uploads/2016/11/vivente-1.jpg",
            link: "https://www.am-products.nl/kussen/natuurlatex-gezondheidskussen-vivente/",
            materiaal: "natuurlatex"
          },
          {
            naam: "Presto 10cm medium",
            image: "https://www.am-products.nl/wp-content/uploads/2016/02/presto-1.jpg",
            link: "https://www.am-products.nl/kussen/talalay-natuurlatex-kussen/",
            materiaal: "talalay"
          },
          {
            naam: "Marcato 13cm soft",
            image: "https://www.am-products.nl/wp-content/uploads/2016/02/marcato-1.jpg",
            link: "https://www.am-products.nl/kussen/talalay-natuurlatex-hoofdkussen-marcato/",
            materiaal: "talalay"
          }
        ],
        buik: [

        ]
      }
    },
    medium: {
      smal: {
        rug: [
          {
            naam: "Nobile 450 gram",
            image: "https://www.am-products.nl/wp-content/uploads/2016/11/nobile-1.jpg",
            link: "https://www.am-products.nl/kussen/dons-hoofdkussen-nobile/",
            materiaal: "dons"
          },
          {
            naam: "Eminent 12cm",
            image: "https://www.am-products.nl/wp-content/uploads/2016/02/eminent-1.jpg",
            link: "https://www.am-products.nl/kussen/dons-natuurlatex-hoofdkussen-eminent/",
            materiaal: "dons"
          },
          {
            naam: "Rondo 12cm",
            image: "https://www.am-products.nl/wp-content/uploads/2017/06/rondo.jpg",
            link: "https://www.am-products.nl/kussen/traagschuim-kussen-rondo/",
            materiaal: "mindfoam"
          },
          {
            naam: "Coda 11cm",
            image: "https://www.am-products.nl/wp-content/uploads/2016/02/coda.jpg",
            link: "https://www.am-products.nl/kussen/traagschuim-hoofdkussen-coda/",
            materiaal: "mindfoam"
          },
          {
            naam: "Fresco 11cm",
            image: "https://www.am-products.nl/wp-content/uploads/2018/12/fresco-1.jpg",
            link: "https://www.am-products.nl/kussen/ventilerend-traagschuim-hoofdkussen-fresco/",
            materiaal: "mindfoam"
          },
          {
            naam: "Sonate 12cm soft",
            image: "https://www.am-products.nl/wp-content/uploads/2016/02/sonate-1.jpg",
            link: "https://www.am-products.nl/kussen/latex-kussen-sonate/",
            materiaal: "natuurlatex"
          },
          {
            naam: "Inventio 12cm soft",
            image: "https://www.am-products.nl/wp-content/uploads/2020/02/inventio.jpg",
            link: "https://www.am-products.nl/kussen/ergonomisch-natuurlatex-hoofdkussen-inventio/",
            materiaal: "natuurlatex"
          },
          {
            naam: "Allegro 11cm soft",
            image: "https://www.am-products.nl/wp-content/uploads/2016/02/allegro-1.jpg",
            link: "https://www.am-products.nl/kussen/talalay-latex-hoofdkussen-allegro/",
            materiaal: "talalay"
          },
          {
            naam: "Marcato 11cm soft",
            image: "https://www.am-products.nl/wp-content/uploads/2016/02/marcato-1.jpg",
            link: "https://www.am-products.nl/kussen/talalay-natuurlatex-hoofdkussen-marcato/",
            materiaal: "talalay"
          }
        ],
        zij: [
          {
            naam: "Eminent 12cm",
            image: "https://www.am-products.nl/wp-content/uploads/2016/02/eminent-1.jpg",
            link: "https://www.am-products.nl/kussen/dons-natuurlatex-hoofdkussen-eminent/",
            materiaal: "dons"
          },
          {
            naam: "Rondo 12cm",
            image: "https://www.am-products.nl/wp-content/uploads/2017/06/rondo.jpg",
            link: "https://www.am-products.nl/kussen/traagschuim-kussen-rondo/",
            materiaal: "mindfoam"
          },
          {
            naam: "Fresco 11cm",
            image: "https://www.am-products.nl/wp-content/uploads/2018/12/fresco-1.jpg",
            link: "https://www.am-products.nl/kussen/ventilerend-traagschuim-hoofdkussen-fresco/",
            materiaal: "mindfoam"
          },
          {
            naam: "Sonate 12cm soft",
            image: "https://www.am-products.nl/wp-content/uploads/2016/02/sonate-1.jpg",
            link: "https://www.am-products.nl/kussen/latex-kussen-sonate/",
            materiaal: "natuurlatex"
          },
          {
            naam: "Inventio 9cm medium",
            image: "https://www.am-products.nl/wp-content/uploads/2020/02/inventio.jpg",
            link: "https://www.am-products.nl/kussen/ergonomisch-natuurlatex-hoofdkussen-inventio/",
            materiaal: "natuurlatex"
          },
          {
            naam: "Vivente 12cm soft",
            image: "https://www.am-products.nl/wp-content/uploads/2016/11/vivente-1.jpg",
            link: "https://www.am-products.nl/kussen/natuurlatex-gezondheidskussen-vivente/",
            materiaal: "natuurlatex"
          },
          {
            naam: "Presto 10cm medium",
            image: "https://www.am-products.nl/wp-content/uploads/2016/02/presto-1.jpg",
            link: "https://www.am-products.nl/kussen/talalay-natuurlatex-kussen/",
            materiaal: "talalay"
          },
          {
            naam: "Marcato 11cm medium",
            image: "https://www.am-products.nl/wp-content/uploads/2016/02/marcato-1.jpg",
            link: "https://www.am-products.nl/kussen/talalay-natuurlatex-hoofdkussen-marcato/",
            materiaal: "talalay"
          }
        ],
        buik: [
          {
            naam: "Nobile 450 gram",
            image: "https://www.am-products.nl/wp-content/uploads/2016/11/nobile-1.jpg",
            link: "https://www.am-products.nl/kussen/dons-hoofdkussen-nobile/",
            materiaal: "dons"
          },
          {
            naam: "Sonate 12cm soft",
            image: "https://www.am-products.nl/wp-content/uploads/2016/02/sonate-1.jpg",
            link: "https://www.am-products.nl/kussen/latex-kussen-sonate/",
            materiaal: "natuurlatex"
          },
          {
            naam: "Inventio 9cm soft",
            image: "https://www.am-products.nl/wp-content/uploads/2020/02/inventio.jpg",
            link: "https://www.am-products.nl/kussen/ergonomisch-natuurlatex-hoofdkussen-inventio/",
            materiaal: "natuurlatex"
          }
        ]
      },
      normaal: {
        rug: [
          {
            naam: "Nobile 450 gram",
            image: "https://www.am-products.nl/wp-content/uploads/2016/11/nobile-1.jpg",
            link: "https://www.am-products.nl/kussen/dons-hoofdkussen-nobile/",
            materiaal: "dons"
          },
          {
            naam: "Eminent 12cm",
            image: "https://www.am-products.nl/wp-content/uploads/2016/02/eminent-1.jpg",
            link: "https://www.am-products.nl/kussen/dons-natuurlatex-hoofdkussen-eminent/",
            materiaal: "dons"
          },
          {
            naam: "Rondo 12cm",
            image: "https://www.am-products.nl/wp-content/uploads/2017/06/rondo.jpg",
            link: "https://www.am-products.nl/kussen/traagschuim-kussen-rondo/",
            materiaal: "mindfoam"
          },
          {
            naam: "Coda 11cm",
            image: "https://www.am-products.nl/wp-content/uploads/2016/02/coda.jpg",
            link: "https://www.am-products.nl/kussen/traagschuim-hoofdkussen-coda/",
            materiaal: "mindfoam"
          },
          {
            naam: "Fresco 11cm",
            image: "https://www.am-products.nl/wp-content/uploads/2018/12/fresco-1.jpg",
            link: "https://www.am-products.nl/kussen/ventilerend-traagschuim-hoofdkussen-fresco/",
            materiaal: "mindfoam"
          },
          {
            naam: "Sonate 12cm soft",
            image: "https://www.am-products.nl/wp-content/uploads/2016/02/sonate-1.jpg",
            link: "https://www.am-products.nl/kussen/latex-kussen-sonate/",
            materiaal: "natuurlatex"
          },
          {
            naam: "Inventio 12cm soft",
            image: "https://www.am-products.nl/wp-content/uploads/2020/02/inventio.jpg",
            link: "https://www.am-products.nl/kussen/ergonomisch-natuurlatex-hoofdkussen-inventio/",
            materiaal: "natuurlatex"
          },
          {
            naam: "Allegro 11cm soft",
            image: "https://www.am-products.nl/wp-content/uploads/2016/02/allegro-1.jpg",
            link: "https://www.am-products.nl/kussen/talalay-latex-hoofdkussen-allegro/",
            materiaal: "talalay"
          },
          {
            naam: "Marcato 11cm soft",
            image: "https://www.am-products.nl/wp-content/uploads/2016/02/marcato-1.jpg",
            link: "https://www.am-products.nl/kussen/talalay-natuurlatex-hoofdkussen-marcato/",
            materiaal: "talalay"
          }
        ],
        zij: [
          {
            naam: "Eminent 12cm",
            image: "https://www.am-products.nl/wp-content/uploads/2016/02/eminent-1.jpg",
            link: "https://www.am-products.nl/kussen/dons-natuurlatex-hoofdkussen-eminent/",
            materiaal: "dons"
          },
          {
            naam: "Rondo 12cm",
            image: "https://www.am-products.nl/wp-content/uploads/2017/06/rondo.jpg",
            link: "https://www.am-products.nl/kussen/traagschuim-kussen-rondo/",
            materiaal: "mindfoam"
          },
          {
            naam: "Fresco 11cm",
            image: "https://www.am-products.nl/wp-content/uploads/2018/12/fresco-1.jpg",
            link: "https://www.am-products.nl/kussen/ventilerend-traagschuim-hoofdkussen-fresco/",
            materiaal: "mindfoam"
          },
          {
            naam: "Sonate 14cm soft",
            image: "https://www.am-products.nl/wp-content/uploads/2016/02/sonate-1.jpg",
            link: "https://www.am-products.nl/kussen/latex-kussen-sonate/",
            materiaal: "natuurlatex"
          },
          {
            naam: "Inventio 12cm soft",
            image: "https://www.am-products.nl/wp-content/uploads/2020/02/inventio.jpg",
            link: "https://www.am-products.nl/kussen/ergonomisch-natuurlatex-hoofdkussen-inventio/",
            materiaal: "natuurlatex"
          },
          {
            naam: "Vivente 12cm soft",
            image: "https://www.am-products.nl/wp-content/uploads/2016/11/vivente-1.jpg",
            link: "https://www.am-products.nl/kussen/natuurlatex-gezondheidskussen-vivente/",
            materiaal: "natuurlatex"
          },
          {
            naam: "Presto 10cm medium",
            image: "https://www.am-products.nl/wp-content/uploads/2016/02/presto-1.jpg",
            link: "https://www.am-products.nl/kussen/talalay-natuurlatex-kussen/",
            materiaal: "talalay"
          },
          {
            naam: "Marcato 11cm medium",
            image: "https://www.am-products.nl/wp-content/uploads/2016/02/marcato-1.jpg",
            link: "https://www.am-products.nl/kussen/talalay-natuurlatex-hoofdkussen-marcato/",
            materiaal: "talalay"
          }
        ],
        buik: [
          {
            naam: "Nobile 450 gram",
            image: "https://www.am-products.nl/wp-content/uploads/2016/11/nobile-1.jpg",
            link: "https://www.am-products.nl/kussen/dons-hoofdkussen-nobile/",
            materiaal: "dons"
          },
          {
            naam: "Sonate 12cm soft",
            image: "https://www.am-products.nl/wp-content/uploads/2016/02/sonate-1.jpg",
            link: "https://www.am-products.nl/kussen/latex-kussen-sonate/",
            materiaal: "natuurlatex"
          },
          {
            naam: "Inventio 9cm soft",
            image: "https://www.am-products.nl/wp-content/uploads/2020/02/inventio.jpg",
            link: "https://www.am-products.nl/kussen/ergonomisch-natuurlatex-hoofdkussen-inventio/",
            materiaal: "natuurlatex"
          }
        ]
      },
      breed: {
        rug: [
          {
            naam: "Nobile 600 gram",
            image: "https://www.am-products.nl/wp-content/uploads/2016/11/nobile-1.jpg",
            link: "https://www.am-products.nl/kussen/dons-hoofdkussen-nobile/",
            materiaal: "dons"
          },
          {
            naam: "Eminent 12cm",
            image: "https://www.am-products.nl/wp-content/uploads/2016/02/eminent-1.jpg",
            link: "https://www.am-products.nl/kussen/dons-natuurlatex-hoofdkussen-eminent/",
            materiaal: "dons"
          },
          {
            naam: "Rondo 12cm",
            image: "https://www.am-products.nl/wp-content/uploads/2017/06/rondo.jpg",
            link: "https://www.am-products.nl/kussen/traagschuim-kussen-rondo/",
            materiaal: "mindfoam"
          },
          {
            naam: "Coda 13cm",
            image: "https://www.am-products.nl/wp-content/uploads/2016/02/coda.jpg",
            link: "https://www.am-products.nl/kussen/traagschuim-hoofdkussen-coda/",
            materiaal: "mindfoam"
          },
          {
            naam: "Fresco 11cm",
            image: "https://www.am-products.nl/wp-content/uploads/2018/12/fresco-1.jpg",
            link: "https://www.am-products.nl/kussen/ventilerend-traagschuim-hoofdkussen-fresco/",
            materiaal: "mindfoam"
          },
          {
            naam: "Sonate 14cm soft",
            image: "https://www.am-products.nl/wp-content/uploads/2016/02/sonate-1.jpg",
            link: "https://www.am-products.nl/kussen/latex-kussen-sonate/",
            materiaal: "natuurlatex"
          },
          {
            naam: "Inventio 14cm soft",
            image: "https://www.am-products.nl/wp-content/uploads/2020/02/inventio.jpg",
            link: "https://www.am-products.nl/kussen/ergonomisch-natuurlatex-hoofdkussen-inventio/",
            materiaal: "natuurlatex"
          },
          {
            naam: "Allegro 13cm soft",
            image: "https://www.am-products.nl/wp-content/uploads/2016/02/allegro-1.jpg",
            link: "https://www.am-products.nl/kussen/talalay-latex-hoofdkussen-allegro/",
            materiaal: "talalay"
          },
          {
            naam: "Marcato 13cm soft",
            image: "https://www.am-products.nl/wp-content/uploads/2016/02/marcato-1.jpg",
            link: "https://www.am-products.nl/kussen/talalay-natuurlatex-hoofdkussen-marcato/",
            materiaal: "talalay"
          }
        ],
        zij: [
          {
            naam: "Eminent 14cm",
            image: "https://www.am-products.nl/wp-content/uploads/2016/02/eminent-1.jpg",
            link: "https://www.am-products.nl/kussen/dons-natuurlatex-hoofdkussen-eminent/",
            materiaal: "dons"
          },
          {
            naam: "Rondo 14cm",
            image: "https://www.am-products.nl/wp-content/uploads/2017/06/rondo.jpg",
            link: "https://www.am-products.nl/kussen/traagschuim-kussen-rondo/",
            materiaal: "mindfoam"
          },
          {
            naam: "Fresco 13cm",
            image: "https://www.am-products.nl/wp-content/uploads/2018/12/fresco-1.jpg",
            link: "https://www.am-products.nl/kussen/ventilerend-traagschuim-hoofdkussen-fresco/",
            materiaal: "mindfoam"
          },
          {
            naam: "Sonate 14cm soft",
            image: "https://www.am-products.nl/wp-content/uploads/2016/02/sonate-1.jpg",
            link: "https://www.am-products.nl/kussen/latex-kussen-sonate/",
            materiaal: "natuurlatex"
          },
          {
            naam: "Inventio 12cm medium",
            image: "https://www.am-products.nl/wp-content/uploads/2020/02/inventio.jpg",
            link: "https://www.am-products.nl/kussen/ergonomisch-natuurlatex-hoofdkussen-inventio/",
            materiaal: "natuurlatex"
          },
          {
            naam: "Vivente 14cm soft",
            image: "https://www.am-products.nl/wp-content/uploads/2016/11/vivente-1.jpg",
            link: "https://www.am-products.nl/kussen/natuurlatex-gezondheidskussen-vivente/",
            materiaal: "natuurlatex"
          },
          {
            naam: "Presto 12cm soft",
            image: "https://www.am-products.nl/wp-content/uploads/2016/02/presto-1.jpg",
            link: "https://www.am-products.nl/kussen/talalay-natuurlatex-kussen/",
            materiaal: "talalay"
          },
          {
            naam: "Marcato 13cm soft",
            image: "https://www.am-products.nl/wp-content/uploads/2016/02/marcato-1.jpg",
            link: "https://www.am-products.nl/kussen/talalay-natuurlatex-hoofdkussen-marcato/",
            materiaal: "talalay"
          }
        ],
        buik: [
          {
            naam: "Nobile 450 gram",
            image: "https://www.am-products.nl/wp-content/uploads/2016/11/nobile-1.jpg",
            link: "https://www.am-products.nl/kussen/dons-hoofdkussen-nobile/",
            materiaal: "dons"
          },
          {
            naam: "Sonate 12cm soft",
            image: "https://www.am-products.nl/wp-content/uploads/2016/02/sonate-1.jpg",
            link: "https://www.am-products.nl/kussen/latex-kussen-sonate/",
            materiaal: "natuurlatex"
          },
          {
            naam: "Inventio 9cm soft",
            image: "https://www.am-products.nl/wp-content/uploads/2020/02/inventio.jpg",
            link: "https://www.am-products.nl/kussen/ergonomisch-natuurlatex-hoofdkussen-inventio/",
            materiaal: "natuurlatex"
          }
        ]
      }
    },
    hard: {
      smal: {
        rug: [
          {
            naam: "Nobile 600 gram",
            image: "https://www.am-products.nl/wp-content/uploads/2016/11/nobile-1.jpg",
            link: "https://www.am-products.nl/kussen/dons-hoofdkussen-nobile/",
            materiaal: "dons"
          },
          {
            naam: "Eminent 12cm",
            image: "https://www.am-products.nl/wp-content/uploads/2016/02/eminent-1.jpg",
            link: "https://www.am-products.nl/kussen/dons-natuurlatex-hoofdkussen-eminent/",
            materiaal: "dons"
          },
          {
            naam: "Rondo 12cm",
            image: "https://www.am-products.nl/wp-content/uploads/2017/06/rondo.jpg",
            link: "https://www.am-products.nl/kussen/traagschuim-kussen-rondo/",
            materiaal: "mindfoam"
          },
          {
            naam: "Coda 11cm",
            image: "https://www.am-products.nl/wp-content/uploads/2016/02/coda.jpg",
            link: "https://www.am-products.nl/kussen/traagschuim-hoofdkussen-coda/",
            materiaal: "mindfoam"
          },
          {
            naam: "Fresco 11cm",
            image: "https://www.am-products.nl/wp-content/uploads/2018/12/fresco-1.jpg",
            link: "https://www.am-products.nl/kussen/ventilerend-traagschuim-hoofdkussen-fresco/",
            materiaal: "mindfoam"
          },
          {
            naam: "Sonate 12cm medium",
            image: "https://www.am-products.nl/wp-content/uploads/2016/02/sonate-1.jpg",
            link: "https://www.am-products.nl/kussen/latex-kussen-sonate/",
            materiaal: "natuurlatex"
          },
          {
            naam: "Inventio 12cm soft",
            image: "https://www.am-products.nl/wp-content/uploads/2020/02/inventio.jpg",
            link: "https://www.am-products.nl/kussen/ergonomisch-natuurlatex-hoofdkussen-inventio/",
            materiaal: "natuurlatex"
          },
          {
            naam: "Allegro 13cm medium",
            image: "https://www.am-products.nl/wp-content/uploads/2016/02/allegro-1.jpg",
            link: "https://www.am-products.nl/kussen/talalay-latex-hoofdkussen-allegro/",
            materiaal: "talalay"
          },
          {
            naam: "Marcato 11cm medium",
            image: "https://www.am-products.nl/wp-content/uploads/2016/02/marcato-1.jpg",
            link: "https://www.am-products.nl/kussen/talalay-natuurlatex-hoofdkussen-marcato/",
            materiaal: "talalay"
          }
        ],
        zij: [
          {
            naam: "Eminent 12cm",
            image: "https://www.am-products.nl/wp-content/uploads/2016/02/eminent-1.jpg",
            link: "https://www.am-products.nl/kussen/dons-natuurlatex-hoofdkussen-eminent/",
            materiaal: "dons"
          },
          {
            naam: "Rondo 12cm",
            image: "https://www.am-products.nl/wp-content/uploads/2017/06/rondo.jpg",
            link: "https://www.am-products.nl/kussen/traagschuim-kussen-rondo/",
            materiaal: "mindfoam"
          },
          {
            naam: "Fresco 11cm",
            image: "https://www.am-products.nl/wp-content/uploads/2018/12/fresco-1.jpg",
            link: "https://www.am-products.nl/kussen/ventilerend-traagschuim-hoofdkussen-fresco/",
            materiaal: "mindfoam"
          },
          {
            naam: "Sonate 12cm medium",
            image: "https://www.am-products.nl/wp-content/uploads/2016/02/sonate-1.jpg",
            link: "https://www.am-products.nl/kussen/latex-kussen-sonate/",
            materiaal: "natuurlatex"
          },
          {
            naam: "Inventio 9cm medium",
            image: "https://www.am-products.nl/wp-content/uploads/2020/02/inventio.jpg",
            link: "https://www.am-products.nl/kussen/ergonomisch-natuurlatex-hoofdkussen-inventio/",
            materiaal: "natuurlatex"
          },
          {
            naam: "Vivente 12cm medium",
            image: "https://www.am-products.nl/wp-content/uploads/2016/11/vivente-1.jpg",
            link: "https://www.am-products.nl/kussen/natuurlatex-gezondheidskussen-vivente/",
            materiaal: "natuurlatex"
          },
          {
            naam: "Presto 10cm medium",
            image: "https://www.am-products.nl/wp-content/uploads/2016/02/presto-1.jpg",
            link: "https://www.am-products.nl/kussen/talalay-natuurlatex-kussen/",
            materiaal: "talalay"
          },
          {
            naam: "Marcato 11cm medium",
            image: "https://www.am-products.nl/wp-content/uploads/2016/02/marcato-1.jpg",
            link: "https://www.am-products.nl/kussen/talalay-natuurlatex-hoofdkussen-marcato/",
            materiaal: "talalay"
          }
        ],
        buik: [
          {
            naam: "Nobile 450 gram",
            image: "https://www.am-products.nl/wp-content/uploads/2016/11/nobile-1.jpg",
            link: "https://www.am-products.nl/kussen/dons-hoofdkussen-nobile/",
            materiaal: "dons"
          },
          {
            naam: "Sonate 12cm soft",
            image: "https://www.am-products.nl/wp-content/uploads/2016/02/sonate-1.jpg",
            link: "https://www.am-products.nl/kussen/latex-kussen-sonate/",
            materiaal: "natuurlatex"
          },
          {
            naam: "Inventio 9cm soft",
            image: "https://www.am-products.nl/wp-content/uploads/2020/02/inventio.jpg",
            link: "https://www.am-products.nl/kussen/ergonomisch-natuurlatex-hoofdkussen-inventio/",
            materiaal: "natuurlatex"
          }
        ]
      },
      normaal: {
        rug: [
          {
            naam: "Nobile 600 gram",
            image: "https://www.am-products.nl/wp-content/uploads/2016/11/nobile-1.jpg",
            link: "https://www.am-products.nl/kussen/dons-hoofdkussen-nobile/",
            materiaal: "dons"
          },
          {
            naam: "Eminent 12cm",
            image: "https://www.am-products.nl/wp-content/uploads/2016/02/eminent-1.jpg",
            link: "https://www.am-products.nl/kussen/dons-natuurlatex-hoofdkussen-eminent/",
            materiaal: "dons"
          },
          {
            naam: "Rondo 12cm",
            image: "https://www.am-products.nl/wp-content/uploads/2017/06/rondo.jpg",
            link: "https://www.am-products.nl/kussen/traagschuim-kussen-rondo/",
            materiaal: "mindfoam"
          },
          {
            naam: "Coda 11cm",
            image: "https://www.am-products.nl/wp-content/uploads/2016/02/coda.jpg",
            link: "https://www.am-products.nl/kussen/traagschuim-hoofdkussen-coda/",
            materiaal: "mindfoam"
          },
          {
            naam: "Fresco 11cm",
            image: "https://www.am-products.nl/wp-content/uploads/2018/12/fresco-1.jpg",
            link: "https://www.am-products.nl/kussen/ventilerend-traagschuim-hoofdkussen-fresco/",
            materiaal: "mindfoam"
          },
          {
            naam: "Sonate 12cm medium",
            image: "https://www.am-products.nl/wp-content/uploads/2016/02/sonate-1.jpg",
            link: "https://www.am-products.nl/kussen/latex-kussen-sonate/",
            materiaal: "natuurlatex"
          },
          {
            naam: "Inventio 12cm soft",
            image: "https://www.am-products.nl/wp-content/uploads/2020/02/inventio.jpg",
            link: "https://www.am-products.nl/kussen/ergonomisch-natuurlatex-hoofdkussen-inventio/",
            materiaal: "natuurlatex"
          },
          {
            naam: "Allegro 13cm medium",
            image: "https://www.am-products.nl/wp-content/uploads/2016/02/allegro-1.jpg",
            link: "https://www.am-products.nl/kussen/talalay-latex-hoofdkussen-allegro/",
            materiaal: "talalay"
          },
          {
            naam: "Marcato 11cm medium",
            image: "https://www.am-products.nl/wp-content/uploads/2016/02/marcato-1.jpg",
            link: "https://www.am-products.nl/kussen/talalay-natuurlatex-hoofdkussen-marcato/",
            materiaal: "talalay"
          }
        ],
        zij: [
          {
            naam: "Eminent 12cm",
            image: "https://www.am-products.nl/wp-content/uploads/2016/02/eminent-1.jpg",
            link: "https://www.am-products.nl/kussen/dons-natuurlatex-hoofdkussen-eminent/",
            materiaal: "dons"
          },
          {
            naam: "Rondo 14cm",
            image: "https://www.am-products.nl/wp-content/uploads/2017/06/rondo.jpg",
            link: "https://www.am-products.nl/kussen/traagschuim-kussen-rondo/",
            materiaal: "mindfoam"
          },
          {
            naam: "Fresco 13cm",
            image: "https://www.am-products.nl/wp-content/uploads/2018/12/fresco-1.jpg",
            link: "https://www.am-products.nl/kussen/ventilerend-traagschuim-hoofdkussen-fresco/",
            materiaal: "mindfoam"
          },
          {
            naam: "Sonate 14cm soft",
            image: "https://www.am-products.nl/wp-content/uploads/2016/02/sonate-1.jpg",
            link: "https://www.am-products.nl/kussen/latex-kussen-sonate/",
            materiaal: "natuurlatex"
          },
          {
            naam: "Inventio 12cm medium",
            image: "https://www.am-products.nl/wp-content/uploads/2020/02/inventio.jpg",
            link: "https://www.am-products.nl/kussen/ergonomisch-natuurlatex-hoofdkussen-inventio/",
            materiaal: "natuurlatex"
          },
          {
            naam: "Vivente 14cm soft",
            image: "https://www.am-products.nl/wp-content/uploads/2016/11/vivente-1.jpg",
            link: "https://www.am-products.nl/kussen/natuurlatex-gezondheidskussen-vivente/",
            materiaal: "natuurlatex"
          },
          {
            naam: "Presto 12cm medium",
            image: "https://www.am-products.nl/wp-content/uploads/2016/02/presto-1.jpg",
            link: "https://www.am-products.nl/kussen/talalay-natuurlatex-kussen/",
            materiaal: "talalay"
          },
          {
            naam: "Marcato 11cm medium",
            image: "https://www.am-products.nl/wp-content/uploads/2016/02/marcato-1.jpg",
            link: "https://www.am-products.nl/kussen/talalay-natuurlatex-hoofdkussen-marcato/",
            materiaal: "talalay"
          }
        ],
        buik: [
          {
            naam: "Nobile 450 gram",
            image: "https://www.am-products.nl/wp-content/uploads/2016/11/nobile-1.jpg",
            link: "https://www.am-products.nl/kussen/dons-hoofdkussen-nobile/",
            materiaal: "dons"
          },
          {
            naam: "Sonate 12cm soft",
            image: "https://www.am-products.nl/wp-content/uploads/2016/02/sonate-1.jpg",
            link: "https://www.am-products.nl/kussen/latex-kussen-sonate/",
            materiaal: "natuurlatex"
          },
          {
            naam: "Inventio 9cm soft",
            image: "https://www.am-products.nl/wp-content/uploads/2020/02/inventio.jpg",
            link: "https://www.am-products.nl/kussen/ergonomisch-natuurlatex-hoofdkussen-inventio/",
            materiaal: "natuurlatex"
          }
        ]
      },
      breed: {
        rug: [
          {
            naam: "Eminent 12cm",
            image: "https://www.am-products.nl/wp-content/uploads/2016/02/eminent-1.jpg",
            link: "https://www.am-products.nl/kussen/dons-natuurlatex-hoofdkussen-eminent/",
            materiaal: "dons"
          },
          {
            naam: "Rondo 12cm",
            image: "https://www.am-products.nl/wp-content/uploads/2017/06/rondo.jpg",
            link: "https://www.am-products.nl/kussen/traagschuim-kussen-rondo/",
            materiaal: "mindfoam"
          },
          {
            naam: "Coda 13cm",
            image: "https://www.am-products.nl/wp-content/uploads/2016/02/coda.jpg",
            link: "https://www.am-products.nl/kussen/traagschuim-hoofdkussen-coda/",
            materiaal: "mindfoam"
          },
          {
            naam: "Fresco 13cm",
            image: "https://www.am-products.nl/wp-content/uploads/2018/12/fresco-1.jpg",
            link: "https://www.am-products.nl/kussen/ventilerend-traagschuim-hoofdkussen-fresco/",
            materiaal: "mindfoam"
          },
          {
            naam: "Sonate 14cm soft",
            image: "https://www.am-products.nl/wp-content/uploads/2016/02/sonate-1.jpg",
            link: "https://www.am-products.nl/kussen/latex-kussen-sonate/",
            materiaal: "natuurlatex"
          },
          {
            naam: "Inventio 14cm soft",
            image: "https://www.am-products.nl/wp-content/uploads/2020/02/inventio.jpg",
            link: "https://www.am-products.nl/kussen/ergonomisch-natuurlatex-hoofdkussen-inventio/",
            materiaal: "natuurlatex"
          },
          {
            naam: "Allegro 13cm medium",
            image: "https://www.am-products.nl/wp-content/uploads/2016/02/allegro-1.jpg",
            link: "https://www.am-products.nl/kussen/talalay-latex-hoofdkussen-allegro/",
            materiaal: "talalay"
          },
          {
            naam: "Marcato 13cm medium",
            image: "https://www.am-products.nl/wp-content/uploads/2016/02/marcato-1.jpg",
            link: "https://www.am-products.nl/kussen/talalay-natuurlatex-hoofdkussen-marcato/",
            materiaal: "talalay"
          }
        ],
        zij: [
          {
            naam: "Eminent 14cm",
            image: "https://www.am-products.nl/wp-content/uploads/2016/02/eminent-1.jpg",
            link: "https://www.am-products.nl/kussen/dons-natuurlatex-hoofdkussen-eminent/",
            materiaal: "dons"
          },
          {
            naam: "Rondo 14cm",
            image: "https://www.am-products.nl/wp-content/uploads/2017/06/rondo.jpg",
            link: "https://www.am-products.nl/kussen/traagschuim-kussen-rondo/",
            materiaal: "mindfoam"
          },
          {
            naam: "Fresco 13cm",
            image: "https://www.am-products.nl/wp-content/uploads/2018/12/fresco-1.jpg",
            link: "https://www.am-products.nl/kussen/ventilerend-traagschuim-hoofdkussen-fresco/",
            materiaal: "mindfoam"
          },
          {
            naam: "Sonate 14cm medium",
            image: "https://www.am-products.nl/wp-content/uploads/2016/02/sonate-1.jpg",
            link: "https://www.am-products.nl/kussen/latex-kussen-sonate/",
            materiaal: "natuurlatex"
          },
          {
            naam: "Inventio 14cm medium",
            image: "https://www.am-products.nl/wp-content/uploads/2020/02/inventio.jpg",
            link: "https://www.am-products.nl/kussen/ergonomisch-natuurlatex-hoofdkussen-inventio/",
            materiaal: "natuurlatex"
          },
          {
            naam: "Vivente 14cm medium",
            image: "https://www.am-products.nl/wp-content/uploads/2016/11/vivente-1.jpg",
            link: "https://www.am-products.nl/kussen/natuurlatex-gezondheidskussen-vivente/",
            materiaal: "natuurlatex"
          },
          {
            naam: "Presto 12cm medium",
            image: "https://www.am-products.nl/wp-content/uploads/2016/02/presto-1.jpg",
            link: "https://www.am-products.nl/kussen/talalay-natuurlatex-kussen/",
            materiaal: "talalay"
          },
          {
            naam: "Marcato 13cm medium",
            image: "https://www.am-products.nl/wp-content/uploads/2016/02/marcato-1.jpg",
            link: "https://www.am-products.nl/kussen/talalay-natuurlatex-hoofdkussen-marcato/",
            materiaal: "talalay"
          }
        ],
        buik: [
          {
            naam: "Nobile 450 gram",
            image: "https://www.am-products.nl/wp-content/uploads/2016/11/nobile-1.jpg",
            link: "https://www.am-products.nl/kussen/dons-hoofdkussen-nobile/",
            materiaal: "dons"
          },
          {
            naam: "Sonate 12cm soft",
            image: "https://www.am-products.nl/wp-content/uploads/2016/02/sonate-1.jpg",
            link: "https://www.am-products.nl/kussen/latex-kussen-sonate/",
            materiaal: "natuurlatex"
          },
          {
            naam: "Inventio 9cm soft",
            image: "https://www.am-products.nl/wp-content/uploads/2020/02/inventio.jpg",
            link: "https://www.am-products.nl/kussen/ergonomisch-natuurlatex-hoofdkussen-inventio/",
            materiaal: "natuurlatex"
          }
        ]
      }
    }
  }
};
